module.exports = __webpack_public_path__ + "img/motor_no31.7836428a.jpg";